import { redirect } from '@tanstack/react-router'
import { UserRole } from '@/constants/user'

export const login = (user) => {
  localStorage.setItem('user', JSON.stringify(user))
}

export const logout = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('smartView')
  localStorage.removeItem('queueId')
}

export const isAdmin = () => {
  const user = getUser()
  return !user ? false : user?.role === UserRole.ADMINISTRATOR
}

export const isSupervisor = () => {
  const user = getUser()
  return !user ? false : user?.role === UserRole.SUPERVISOR
}

export function isRoleTeamLeader() {
  const user = getUser()
  return !user ? false : user?.role === UserRole.TEAM_LEADER
}

export function isRoleAgent() {
  const user = getUser()
  return !user ? false : user?.role === UserRole.AGENT
}

export function checkIsViewAsMode() {
  return !!sessionStorage.getItem('viewAsUserData')
}

export const getUser = () => {
  try {
    const sessionUser = sessionStorage.getItem('viewAsUserData')
    if (sessionUser) {
      return JSON.parse(sessionUser)
    }
    return JSON.parse(localStorage.getItem('user'))
  } catch {
    return null
  }
}

export const saveQueueId = (queueId) => {
  localStorage.setItem('queueId', String(queueId))
}

export const getQueueId = () => {
  return localStorage.getItem('queueId') || null
}

export const navigateGuard = (location, roleAccess) => {
  const user = getUser()
  if (!user) {
    throw redirect({
      to: '/login',
      search: {
        redirect: location.href,
      },
    })
  }
  if (roleAccess && !viewGuard(roleAccess)) {
    throw redirect({
      to: '/page-404',
      search: {
        title: 'Cảnh báo',
        message: `Bạn không có quyền sử dụng tính năng này!`,
      },
    })
  }
}

export const viewGuard = (roleAccess) => {
  const user = getUser()
  if (!user) return false
  if (roleAccess) {
    return roleAccess.includes(user.role)
  }
  return true
}

export const viewAsModeGuard = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  if (!user || !user.admin) {
    throw redirect({
      to: '/page-404',
      search: {
        title: 'Cảnh báo',
        message: `Bạn không có quyền sử dụng tính năng này!`,
      },
    })
  }
  return true
}
